import React from 'react';
import PropTypes from 'prop-types';

import {
    Label,
    Text,
} from '@zillow/constellation';

import TourCardEditable from 'app/shared/components/postingPath/TourCardEditable';

import { StyledRow, StyledCol } from './StyledComponents';

const LISTING_TOUR_TEXT = {
    amenity: {
        title: 'Building Tour',
        helper: 'Add a 3D tour that highlights your building’s amenities and common areas.',
    },
    singleFamily: {
        title: '3D Tour',
        helper: 'Add a 3D tour that highlights your property to prospective tenants.',
    },
};

const propTypes = {
    tours: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        createdDate: PropTypes.string.isRequired,
        creatorName: PropTypes.string.isRequired,
        imageSrc: PropTypes.string,
        state: PropTypes.oneOf(['active', 'inactive', 'empty']),
    })),
    tourType: PropTypes.oneOf(['amenity', 'singleFamily']),
    formData: PropTypes.object.isRequired,
    updateStatusMessage: PropTypes.func.isRequired,
    updateFormData: PropTypes.func.isRequired,
};

const defaultProps = {
    tours: [{
        name: '',
        createdDate: '',
        creatorName: '',
        imageSrc: '',
        state: 'empty',
    }],
    tourType: 'amenity',
};

const ListingTour = ({
    formData,
    tours,
    tourType,
    isDisabled,
    updateStatusMessage,
    updateFormData,
}) => (
    <React.Fragment>
        <Text fontType="h5" marginBottom="xs" as="div">
            {LISTING_TOUR_TEXT[tourType].title}
        </Text>
        <Label>
            {LISTING_TOUR_TEXT[tourType].helper}
        </Label>
        <StyledRow>
            {tours.map(tour => (
                <StyledCol>
                    <TourCardEditable
                        formData={formData}
                        tour={tour}
                        tourType={tourType}
                        hasBigBottomBorder={true}
                        isDisabled={isDisabled}
                        size="md"
                        updateStatusMessage={updateStatusMessage}
                        updateFormData={updateFormData}
                    />
                </StyledCol>
            ))}
        </StyledRow>
    </React.Fragment>
);

ListingTour.propTypes = propTypes;
ListingTour.defaultProps = defaultProps;

export { ListingTour };
export default ListingTour;
